'use client';

import React from 'react';
import NextLink from 'next/link';

import { Link as CloudUILink, LinkProps } from '@unity/cloud-ui';
import { useLocale } from 'next-intl';

export const Link = (props: LinkProps) => {
  const locale = useLocale();
  if (!props?.href) {
    return <React.Fragment>{props.children}</React.Fragment>;
  }

  const href = props.href.startsWith('/') ? `/${locale.toLowerCase()}${props.href}` : props.href;

  return <CloudUILink {...props} href={href} component={NextLink} />;
};
